import './Navigation.css';
import userIcon from '../../Assets/Images/RegisterPage/user.png';
import logo from '../../Assets/logo.png';

import Cookies from 'js-cookie';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchProfile } from '../../services/user';
import downArrow from '../../Assets/downarrow.png';
import {   ReceiveQuestions as pyschometricTest} from '../../services/PyschometricQuestions';
import {   CheckTestStatus, ReceiveQuestions as knowledgeTest} from '../../services/KnowledgeTest';

function Header({recentlyUpdated=false, disabledNavigation=false}){
    const navigate = useNavigate();
    const location = useLocation();
    const [userIconField, setUserIcon] = useState(userIcon);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [userDetails, setUserDetails] = useState({
        'name': Cookies.get('name'),
        'email': Cookies.get('email')
    });
    const [pyschometricTestStatus,setPyschometricTestStatus]=useState('START');
   const [knowledgeTestStatus,setKnowledgeTestStatus]=useState('START');

    useEffect(() => {
        const updateProfileImage = async () => {
            try {
                const storedImage = sessionStorage.getItem('profileImage');
                
                // If we have a stored image and it's not the default, and we don't need to update
                if (storedImage && storedImage !== "No image uploaded" && !recentlyUpdated) {
                    setUserIcon(storedImage);
                    return;
                }
                
                // Otherwise, fetch from backend
                const response = await fetchProfile();
                
                if (response.success) {
                    const profileImage = response.data.profileImage;
                    console.log('Profile response:', response);
                    
                    if (profileImage && profileImage !== "No image uploaded") {
                        setUserIcon(profileImage);
                        sessionStorage.setItem('profileImage', profileImage);
                    } else {
                        // Keep default icon
                        setUserIcon(userIcon);
                        sessionStorage.setItem('profileImage', 'No image uploaded');
                    }
                } else {
                    setUserIcon(userIcon);
                    sessionStorage.setItem('profileImage', 'No image uploaded');
                }
            } catch (error) {
                console.error("Error fetching profile:", error);
                setUserIcon(userIcon);
            }
        };

        updateProfileImage();
    }, [recentlyUpdated]);

    const handleLogout = () => {

        Object.keys(Cookies.get()).forEach(cookie=>Cookies.remove(cookie));
        localStorage.clear();
        sessionStorage.clear();
        navigate('/login');
    };

   
   useEffect(()=>{
      CheckForTest();
   },[]);

 async function CheckForTest() {
    const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes
    
    // Check if cache is still valid
    const lastFetched = sessionStorage.getItem('testStatusTimestamp');
    const isCacheExpired = !lastFetched || (Date.now() - parseInt(lastFetched) > CACHE_DURATION);
    
    // Psychometric Test
    if (sessionStorage.getItem('pyschometricTestStatus') && !isCacheExpired) {
        setPyschometricTestStatus(sessionStorage.getItem('pyschometricTestStatus'));
    } else {
        const pyschometricStatus = await pyschometricTest();
        const status = pyschometricStatus?.completed ? "COMPLETED" : "START";
        sessionStorage.setItem('pyschometricTestStatus', status);
        setPyschometricTestStatus(status);
        sessionStorage.setItem('testStatusTimestamp', Date.now().toString());
    }
    
    // Knowledge Test
    if (sessionStorage.getItem('knowledgeTestStatus') && !isCacheExpired) {
        setKnowledgeTestStatus(sessionStorage.getItem('knowledgeTestStatus'));
    } else {
        const knowledgeStatus = await CheckTestStatus();
        const status = knowledgeStatus?.completed ? "COMPLETED" : "START";
        sessionStorage.setItem('knowledgeTestStatus', status);
        setKnowledgeTestStatus(status);
        sessionStorage.setItem('testStatusTimestamp', Date.now().toString());
    }
}
   
    return(
        <div className='header'>
            <div className='headercontainer'>
                <div className='left_part'>
                    <img src={logo} alt="logo"/>
                </div>
                <div className='right_part'>
                    <h2 
                        onClick={() => navigate('/homepage')} 
                        className={`pointer ${location.pathname === '/homepage' ? 'active' : ''}`}  
                        style={{pointerEvents: disabledNavigation ? 'none' : 'auto'}}
                    >
                        Home
                    </h2>
                    <h2 
                        onClick={() =>  knowledgeTestStatus==="COMPLETED"?navigate('/knowledgeTest/questions/score'):navigate('/knowledgetest')} 
                        className={`pointer ${location.pathname === '/knowledgetest' ? 'active' : ''}`} 
                        style={{pointerEvents: disabledNavigation ? 'none' : 'auto'}}
                    >
                        Knowledge Test
                    </h2>
                    <h2 
                        onClick={() =>pyschometricTestStatus==="COMPLETED" ?navigate('/pyschometrictest/questions/score'):navigate('/pyschometrictest')} 
                        className={`pointer ${location.pathname === '/pyschometrictest' ? 'active' : ''}`} 
                        style={{pointerEvents: disabledNavigation ? 'none' : 'auto'}}
                    >
                        Psychometric Test
                    </h2>
                    <h2 
                        onClick={() => navigate('/viewdetailedreport')} 
                        className={`pointer ${location.pathname === '/viewdetailedreport' ? 'active' : ''}`} 
                        style={{pointerEvents: disabledNavigation ? 'none' : 'auto'}}
                    >
                        View Detailed Reports
                    </h2>
                    <div 
                        className='headermenu' 
                        onClick={() => setIsMenuOpen(!isMenuOpen)} 
                        style={{pointerEvents: disabledNavigation ? 'none' : 'auto'}}
                    >
                        <img 
                            src={userIconField} 
                            alt="auth_icon" 
                            width="40" 
                            height="40"
                            style={{borderRadius: "50%", objectFit: "cover"}} 
                            className='authicon'
                            onError={(e) => {
                                console.log('Image load error, using default');
                                e.target.src = userIcon;
                            }}
                        />
                        <div className='userdetails'>
                            <h3>{userDetails.name}</h3>
                            <h4>{userDetails.email}</h4>
                        </div>
                        <img src={downArrow} alt="dropdown" />
                    </div>
                </div>
            </div>
            <div 
                className='right_partmenu' 
                style={{display: isMenuOpen ? 'flex' : 'none'}}
            >
                <h3 onClick={() => {navigate('/changepassword'); setIsMenuOpen(false);}}>
                    Change Password
                </h3>
                <h3 onClick={() => {navigate('/profilesetup'); setIsMenuOpen(false);}}>
                    Update Profile
                </h3>
                <h3 onClick={() => handleLogout()}>
                    Logout
                </h3>
            </div>
        </div>
    );
}

export default Header;